import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import auth from './auth'
import report from './report'
import activityApply from './activityApply'
import * as modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({

  modules: {
    app,
    auth,
    report,
    activityApply,
    ...modules
  }

})
